var chunkMapping = {
	"47": [
		8047
	],
	"361": [
		361
	],
	"501": [
		5501
	],
	"557": [
		557
	],
	"797": [
		5797
	],
	"817": [
		4817
	]
};
var idToExternalAndNameMapping = {
	"361": [
		"default",
		"./Reservations",
		3521
	],
	"557": [
		"default",
		"./Properties",
		1594
	],
	"4817": [
		"default",
		"./Home",
		4162
	],
	"5501": [
		"default",
		"./Favorites",
		2765
	],
	"5797": [
		"default",
		"./Trips",
		9737
	],
	"8047": [
		"default",
		"./Categories",
		366
	]
};
var idToRemoteMap = {
	"361": [
		{
			"externalType": "script",
			"name": "airbnb_reservations"
		}
	],
	"557": [
		{
			"externalType": "script",
			"name": "airbnb_properties"
		}
	],
	"4817": [
		{
			"externalType": "script",
			"name": "airbnb_home"
		}
	],
	"5501": [
		{
			"externalType": "script",
			"name": "airbnb_favorites"
		}
	],
	"5797": [
		{
			"externalType": "script",
			"name": "airbnb_trips"
		}
	],
	"8047": [
		{
			"externalType": "script",
			"name": "airbnb_categories"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"361": {
		"shareScope": "default",
		"name": "./Reservations",
		"externalModuleId": 3521,
		"remoteName": "airbnb_reservations"
	},
	"557": {
		"shareScope": "default",
		"name": "./Properties",
		"externalModuleId": 1594,
		"remoteName": "airbnb_properties"
	},
	"4817": {
		"shareScope": "default",
		"name": "./Home",
		"externalModuleId": 4162,
		"remoteName": "airbnb_home"
	},
	"5501": {
		"shareScope": "default",
		"name": "./Favorites",
		"externalModuleId": 2765,
		"remoteName": "airbnb_favorites"
	},
	"5797": {
		"shareScope": "default",
		"name": "./Trips",
		"externalModuleId": 9737,
		"remoteName": "airbnb_trips"
	},
	"8047": {
		"shareScope": "default",
		"name": "./Categories",
		"externalModuleId": 366,
		"remoteName": "airbnb_categories"
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}